export default "__VITE_ASSET__BomiawE7__"